/* eslint-disable @typescript-eslint/camelcase */ var messages = {
    dev_app: {
        error: "Unable to process the request.",
        title: "Help",
        video: "Your browser does not support HTML video."
    }
};
export default {
    messages: messages
};

//# sourceMappingURL=messages.js.map